import React, {useMemo} from 'react';

import {Card, Block, Dialog, DialogBody, DialogFooter, Button, VF, Space, ModalComponentProps, makeValidate, Yup} from '@mc/ui-v4';

import {Form, FormRenderProps} from 'react-final-form';
import {AttributeConfigVO, CiselnikVO, EnumTypLayerAttr} from '../../../api';
import {koncoveHodnotyCiselniku} from '../../../helpers/DataMutators';

type FormProps = {
    hodnota: string;
};

type Props = ModalComponentProps & {initialValues?: FormProps; atribut: AttributeConfigVO; onSubmit: (data: FormProps) => void};

export const DefaultValueModal: React.FC<Props> = ({onClose, atribut, initialValues, onSubmit}) => {
    const validate = useMemo(
        () =>
            makeValidate(
                Yup.object().shape({
                    hodnota: Yup.mixed().required('Zadejte hodnotu'),
                }),
            ),
        [],
    );

    const renderAttribute = (attribute: AttributeConfigVO, submitting: boolean) => {
        const commons = {
            label: 'Výchozí hodnota',
            required: true,
            name: 'hodnota',
            disabled: submitting,
        };
        switch (attribute.typ) {
            case EnumTypLayerAttr.STRING:
                return <VF.String {...commons} />;
            case EnumTypLayerAttr.TEXT:
                return <VF.TextArea {...commons} />;
            case EnumTypLayerAttr.INT:
                return <VF.Number key={`${attribute.nazev}-${attribute.id}`} {...commons} />;
            case EnumTypLayerAttr.NUMBER:
                return <VF.Number key={`${attribute.nazev}-${attribute.id}`} decimal maximumFractionDigits={4} {...commons} />;
            case EnumTypLayerAttr.BOOLEAN:
                return <VF.Checkbox {...commons} />;
            case EnumTypLayerAttr.ENUM:
                // Výchozí hodnotou může být jen koncová hodnota číselníku – vnitřní uzel stromového
                // číselníku hodnotu atributu nepředstavuje, jde jen o seskupení hodnot (MCW-29258).
                return <VF.SelectBox {...commons} items={koncoveHodnotyCiselniku(atribut.ciselnik)} useIdAsValue getItemId={(c: CiselnikVO) => c?.nazev} />;
            case EnumTypLayerAttr.DATE_TIME:
                return <VF.DateTime {...commons} />;
            default:
                return null;
        }
    };

    return (
        <Form<FormProps> initialValues={initialValues} onSubmit={onSubmit} validate={validate}>
            {({submitting, handleSubmit}: FormRenderProps<FormProps>) => {
                return (
                    <Dialog size="md" onClose={onClose} title={'Nastavení výchozí hodnoty atributu'}>
                        <DialogBody>
                            <Space vertical>
                                <Card mode={'edit'}>
                                    <Block>{renderAttribute(atribut, submitting)}</Block>
                                </Card>
                            </Space>
                        </DialogBody>
                        <DialogFooter>
                            <Button style="default" onClick={onClose} disabled={submitting}>
                                Zrušit
                            </Button>
                            <Button style="primary" onClick={handleSubmit} disabled={submitting}>
                                Uložit
                            </Button>
                        </DialogFooter>
                    </Dialog>
                );
            }}
        </Form>
    );
};
